import React, { Component } from 'react';
import { createGroup } from '../../apis/GroupAPI';
import Paper from '@material-ui/core/Paper';
import TextField from '@material-ui/core/TextField';
import Group from '../../models/Group';
import FormLabel from '@material-ui/core/FormLabel';
import FormControl from '@material-ui/core/FormControl';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Grid from '@material-ui/core/Grid';
import Checkbox from '@material-ui/core/Checkbox';
import { fetchLanguages } from '../../apis/LanguageAPI';
import { fetchGroup } from '../../apis/GroupAPI';
import NavigateIcon from '../../components/NavigateIcon';
import FormHelperText from '@material-ui/core/FormHelperText';
import ButtonLink from '../../components/ButtonLink';
import Loading from '../../components/Loading';
import ErrorMessage from '../../components/ErrorMessage';
import SaveButton from '../../components/SaveButton';
import Header from '../../components/HomeNavigation';

import '../../../css/components/create-group.css';
import NavigationLayout from '../../components/Layouts/NavigationLayout';

const styles = {
  main: {
    marginLeft: '100px',
    marginRight: '100px'
  }
};

class CreateGroup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      error: false,
      saving: false,
      id: null,
      groupName: '',
      channelId: null,
      languages: null,
      checkedLanguages: [],
      formErrors: {
        groupName: false,
        groupNameError: ''
      }
    };
  }

  componentDidMount = async () => {
    const { isEdit } = this.props;
    if (isEdit) {
      await this.setEditState();
    }

    await this.initialise();
  };

  initialise = async () => {
    const { match } = this.props;
    this.state.channelId = match.params.channelId;
    try {
      const languages = await fetchLanguages();
      this.setState({
        languages
      });
    } catch (error) {
      this.setState({
        error: true
      });
    }
  };

  setEditState = async () => {
    const { match } = this.props;

    try {
      const { id, name, channelId, languages } = await fetchGroup(
        match.params.groupName
      );
      this.setState({
        id: id,
        groupName: name,
        channelId: channelId,
        checkedLanguages: languages
      });
    } catch (error) {
      this.setState({
        error: true
      });
    }
  };

  handleChange = name => event => {
    this.setState({
      [name]: event.target.value
    });
  };

  handleLanguageChange = language => event => {
    if (event.target.checked) {
      this.setState({
        checkedLanguages: [...this.state.checkedLanguages, language]
      });
    } else {
      this.setState({
        checkedLanguages: this.state.checkedLanguages.filter(
          lang => lang !== language
        )
      });
    }
  };

  saveGroup = async () => {
    const { id, groupName, channelId, checkedLanguages } = this.state;
    const { isEdit } = this.props;
    const group = new Group(id, groupName, channelId, checkedLanguages);
    if (!this.isFormValid(group)) return;
    const redirectUrl = isEdit
      ? `/channel/${this.state.channelId}/groups/${this.state.groupName}`
      : `/channel/${this.state.channelId}/groups/${
          this.state.groupName
        }/create`;

    try {
      this.setState({ saving: true });
      await createGroup(group);
      this.props.history.push(redirectUrl);
    } catch (error) {
      //check if error code is unknown
      this.setState({
        saving: false,
        formErrors: {
          groupName: true,
          groupNameError: error.message
        }
      });
    }
  };

  isFormValid = group => {
    let result = group.validate();
    this.setState({
      formErrors: {
        groupName: result.name !== undefined ? true : false,
        groupNameError: result.name
      }
    });
    return result.name !== undefined ? false : true;
  };

  render() {
    const { error, saving, languages, formErrors } = this.state;
    const { match, isEdit } = this.props;

    const cancelPath = isEdit
      ? `/channel/${match.params.channelId}/groups/${match.params.groupName}`
      : `/channel/${match.params.channelId}/groups`;

    if (!languages) {
      return error ? <ErrorMessage /> : <Loading />;
    }

    return (
      <NavigationLayout>
        <div>
          <Header isTitle={true} isOperatorHome={false} isGroupHome={false} />
          <div id="create-group" style={styles.main}>
            <NavigateIcon to={cancelPath} id="navigate-cancel" />
            <h2>{isEdit ? 'Edit' : 'Create'} Group </h2>
            <Paper elevation={1}>
              <div id="create-group-form">
                <div>
                  <Grid container justify="center">
                    <Grid item xs>
                      <FormControl
                        className="form-element"
                        aria-describedby="name-error-text"
                      >
                        <TextField
                          autoFocus
                          required
                          disabled={saving}
                          error={formErrors.groupName}
                          id="groupName"
                          label="Group Name"
                          value={this.state.groupName}
                          onChange={this.handleChange('groupName')}
                          margin="normal"
                        />
                        <FormHelperText
                          hidden={!formErrors.groupName}
                          id="name-error-text"
                        >
                          {formErrors.groupNameError}
                        </FormHelperText>
                      </FormControl>
                    </Grid>
                    <Grid item xs>
                      <FormControl className="form-element">
                        <TextField
                          disabled
                          id="channelId"
                          label="Channel Id"
                          value={this.state.channelId}
                          onChange={this.handleChange('channelId')}
                          margin="normal"
                        />
                      </FormControl>
                    </Grid>
                  </Grid>
                </div>
                <div className="form-element">
                  <FormControl component="fieldset">
                    <FormLabel component="legend">Languages</FormLabel>
                    <FormGroup>
                      {languages.map((lang, index) => (
                        <FormControlLabel
                          key={lang.language}
                          label={lang.language}
                          control={
                            <Checkbox
                              id={'chk-lang-' + index}
                              disabled={saving}
                              checked={this.state.checkedLanguages.includes(
                                lang.language
                              )}
                              onChange={this.handleLanguageChange(
                                lang.language
                              )}
                              value={lang.language}
                            />
                          }
                        />
                      ))}
                    </FormGroup>
                  </FormControl>
                </div>
                <div className="form-element">
                  <div className="right">
                    <ButtonLink
                      id="btn-cancel"
                      disabled={saving}
                      path={cancelPath}
                      variant="outlined"
                      color="primary"
                      className="cancel-margin"
                    >
                      Cancel
                    </ButtonLink>
                    <SaveButton
                      id="btn-save-group"
                      saving={saving.toString()}
                      disabled={saving}
                      onClick={this.saveGroup}
                      variant="contained"
                      color="primary"
                    >
                      Save
                    </SaveButton>
                  </div>
                </div>
              </div>
            </Paper>
          </div>
        </div>
      </NavigationLayout>
    );
  }
}

export default CreateGroup;
